import { Button, Input } from '@material-ui/core';
import React from 'react';
import AttachFilesIcon from '../../assets/allIcons/AttachFilesIcon';
import DeleteFileIcon from '../../assets/allIcons/DeleteFileIcon';
import DefaultFileIcon from '../../assets/allIcons/FilesIcons/DefaultFileIcon';
import DocIcon from '../../assets/allIcons/FilesIcons/DocIcon';
import DocxIcon from '../../assets/allIcons/FilesIcons/DocxIcon';
import PdfIcon from '../../assets/allIcons/FilesIcons/PdfIcon';
import TxtIcon from '../../assets/allIcons/FilesIcons/TxtIcon';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { FileDescription, FileName, FileOptions, FilesItem, PageContainer, PreviewFile, RemovedContainer, StyledButton, StyledButtonContainer, StyledFilesUploader, StyledFormValidate, StyledInputContainer } from './Support.style';

const getFileIcon = (fileName) => {
  switch (true) {
    case fileName.toLowerCase().includes('pdf'):
      return <PdfIcon />
    case fileName.toLowerCase().includes('docx'):
      return <DocxIcon />
    case fileName.toLowerCase().includes('doc'):
      return <DocIcon />
    case fileName.toLowerCase().includes('txt'):
      return <TxtIcon />

    default:
      return <DefaultFileIcon />
  }
}

const Support = ({
  email,
  message,
  subject,

  setEmail,
  setMessage,
  setSubject,

  files,
  onHandleFileUpload,
  handleRemoveFile,
  previewFiles,

  submitButtonText,
  onSubmitForm,
}) => {

  return (
    <PageContainer>
      <Breadcrumbs pathArr={[{ label: 'Техподдержка' }]} />
      <StyledFormValidate onSubmit={onSubmitForm}>
        <StyledInputContainer>
          <Input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            fullWidth
            variant="filled"
            required
            placeholder="Тема*"
          />
        </StyledInputContainer>
        <StyledInputContainer>
          <Input
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            variant="filled"
            required
            multiline
            maxRows={4}
            id="message"
            placeholder="Сообщение*"
          />
        </StyledInputContainer>
        <StyledInputContainer>
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            variant="filled"
            required
            id="email"
            placeholder="e-mail*"
            type="email"
          />
        </StyledInputContainer>

        {files.map((item, index) =>
          <FilesItem key={item.lastModified + index.toString()}>
            {item.type.includes('image') && previewFiles.length >= index
              ? <PreviewFile url={previewFiles[index]} />
              : getFileIcon(item.name)
            }
            <FileDescription>
              <FileName>{item.name}</FileName>
              <FileOptions>
                {`${item.name.split('.').pop().toUpperCase()}・${Math.round(item.size / 1024 / 1024 * 10) / 10} MB`}
              </FileOptions>
            </FileDescription>
            <RemovedContainer onClick={() => handleRemoveFile(item)}>
              <DeleteFileIcon />
            </RemovedContainer>
          </FilesItem>
        )}
        <StyledFilesUploader>
          <input
            type="file"
            name='Files'
            multiple
            onChange={(e) => {
              onHandleFileUpload(e)
            }}
            onClick={(e) => {
              e.target.value = null
            }}
          />
          <AttachFilesIcon />
          <span>Прикрепить файл</span>
        </StyledFilesUploader>
        <StyledButtonContainer>
          <Button
            fullWidth
            type="submit"
            size='large'
            variant='contained'
            disabled={!email || !message || !subject}
          >
            {submitButtonText}
          </Button>
        </StyledButtonContainer>
      </StyledFormValidate>



    </PageContainer>
  )
}

export default Support;
